import errorFilledOrange from "../../assets/images/errorFilledOrange.svg";
import errorFilledRed from "../../assets/images/errorFilledRed.svg";
import closeIcon from "../../assets/images/close-outline.svg";
import "./AlertMessage.scss";
import { Dialog } from "primereact/dialog";

export const AlertMessage = ({
  type,
  message,
  className,
  onClose,
  isPopup = false,
}) => {
  return isPopup ? (
    <Dialog
      id={"alert-popup"}
      visible={!!message}
      className={`cargo-alertmsg-dialog ${className || ""}`}
      header={null}
      footer={null}
      closable={false}
      dismissableMask
      draggable={false}
      resizable={false}
      modal
      onHide={() => { }}
    >
      <img
        src={type === "error" ? errorFilledRed : errorFilledOrange}
        alt="alert-warn"
        title={type === "error" ? "Error" : "Warning"}
        className="alert-warn"
      />
      <label className="alert-content">{message}</label>

      <img
        src={closeIcon}
        alt="close-warn"
        title="Close"
        className="close-warn"
        onClick={onClose}
      />
    </Dialog>
  ) : (
    <div className={`cargo-alertmsg-row ${className || ""}`}>
      <img
        src={type === "error" ? errorFilledRed : errorFilledOrange}
        alt="alert-warn"
        title={type === "error" ? "Error" : "Warning"}
        className="alert-warn"
      />
      <label className="alert-content">{message}</label>
    </div>
  );
};
